// extracted by mini-css-extract-plugin
export default {"container":"chat-input_container__1chEI","input":"chat-input_input__0WFlJ","button":"chat-input_button__7Fahx"};